module.exports = __webpack_public_path__ + "img/dybj.5b5ba040.jpg";